export default __webpack_public_path__ + "static/Metropolis-BlackItalic-0988bc2711554fe2280caa45d210eefe.woff2";